import { StyleSheet, Text, View } from 'react-native';
import QRCode from 'react-native-qrcode-svg';
import 'text-encoding';
import theme from 'theme';
import { calcSizeForTv } from 'utils/index';

import ListNumber from './helpers/ListNumber';

import BandplayB from 'assets/favicon.png';

type TvQrContentLayoutProps = {
  title: string;
  url: string;
  qrCodeValue: string;
};

const TvQrContentLayout: React.FC<TvQrContentLayoutProps> = ({ title, url, qrCodeValue }) => (
  <View style={styles.container}>
    <View style={styles.leftContainer}>
      <Text style={styles.title}>{title}</Text>
      <View style={styles.contentBox}>
        <View style={{ ...styles.listItemRow, marginBottom: calcSizeForTv(60) }}>
          <ListNumber number={1} />
          <Text style={styles.listItemText}>
            Acesse
            <Text style={styles.urlText}>{` ${url} `}</Text>
            em seu navegador ou dispositivo móvel
          </Text>
        </View>
        <View style={styles.listItemRow}>
          <ListNumber number={2} />
          <Text style={styles.listItemText}>
            Ou escaneie o QR Code ao lado e acesse com seu smartphone
          </Text>
        </View>
      </View>
    </View>
    {qrCodeValue && (
      <View style={styles.qrCodeContainer}>
        <QRCode
          value={qrCodeValue}
          size={calcSizeForTv(430)}
          backgroundColor="white"
          color="#070D31"
          logo={BandplayB}
          logoSize={calcSizeForTv(70)}
          logoMargin={calcSizeForTv(2)}
        />
      </View>
    )}
  </View>
);

const styles = StyleSheet.create({
  container: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    marginTop: calcSizeForTv(50),
  },
  leftContainer: {
    width: '55%',
  },
  title: {
    fontSize: calcSizeForTv(60),
    lineHeight: calcSizeForTv(80),
    color: 'white',
    marginBottom: calcSizeForTv(70),
    fontFamily: theme.fonts.inter.bold,
  },
  contentBox: {
    width: '100%',
    paddingHorizontal: calcSizeForTv(36),
    paddingVertical: calcSizeForTv(52),
    borderRadius: 23,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(217, 217, 217, 0.075)',
  },
  listItemRow: {
    alignItems: 'center',
    maxWidth: calcSizeForTv(750),
    flexDirection: 'row',
  },
  listItemText: {
    flex: 1,
    color: 'white',
    fontSize: calcSizeForTv(24),
    lineHeight: calcSizeForTv(32),
    marginLeft: calcSizeForTv(32),
    fontFamily: theme.fonts.inter.bold,
    maxWidth: calcSizeForTv(600),
  },
  urlText: {
    color: '#6386FF',
    fontSize: calcSizeForTv(24),
    lineHeight: calcSizeForTv(32),
    fontFamily: theme.fonts.inter.bold,
  },
  qrCodeContainer: {
    backgroundColor: 'white',
    width: calcSizeForTv(450),
    height: calcSizeForTv(450),
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default TvQrContentLayout;
